export default __webpack_public_path__ + "static/media/fold.1e56a664.mp3";